export const ToggleSideBar = () => {
  console.log('toggle action');
  return {
    type: 'TOGGLE_SIDEBAR',
  };
};
